// extracted by mini-css-extract-plugin
module.exports = {"internalContainer":"InternalMenu_internalContainer__g2C9C","internalItem":"InternalMenu_internalItem__AgSd_","internalLink":"InternalMenu_internalLink__My64v"};